import {
  Flex,
  Icons,
} from "@components/index";
import withShow from "@common/withShow";

const iconSizeMap = {
  sm: "22px",
  lg: "35px",
} as const;

const textSizeMap = {
  sm: "14px",
  lg: "20px",
} as const;

interface EmptyFragmentType extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "lg",
}

const EmptyFragment: React.FC<React.PropsWithChildren<EmptyFragmentType>> = ({ children, size = "lg", ...rest }) => (
  <Flex.Col block alignItems="center" justifyContent="center" gap="10px" {...rest}>
    <Icons icon="filter" className="text--neutral--400" style={{ fontSize: iconSizeMap[size] }} />
    <h2 className="text text--neutral--400 bold center" style={{ fontSize: textSizeMap[size] }}>{children}</h2>
  </Flex.Col>
);

export default withShow(EmptyFragment);